module.exports = __webpack_public_path__ + "files/d12eb3f16318166937cf09f31b78a5c6.png";